// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__Ev1D8","selects":"Documents_selects__ZVkxy"};